import { render, staticRenderFns } from "./OrdersFilter.vue?vue&type=template&id=0cb8446e&scoped=true"
import script from "./OrdersFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8446e",
  null
  
)

export default component.exports